import React from "react";
/* asset imports */
import vegetableCart1 from "../assets/images/vegetables/vegetables-1.png";
import vegetableCart2 from "../assets/images/vegetables/vegetables-2.png";
import vegetableCart3 from "../assets/images/vegetables/vegetables-3.png";
import MainCartModal from "./modals/MainCartModal";

const VegetablesCartLarge = ({
  handleCartClick,
  handleCartItemClick,
  activeCartData,
}) => {
  return (
    <>
      <div className="carts-main-wrapper">
        <div className="close-icon" onClick={() => handleCartClick(0)}>
          <span className="material-symbols-rounded">close</span>
        </div>
        <div className="cart-large vegetables-cart-empty">
          <img
            src={vegetableCart1}
            alt=""
            className="inner-img-var-1-1"
            onClick={() => handleCartItemClick("cruciferous-vegetables")}
          />
          <img
            src={vegetableCart2}
            alt=""
            className="inner-img-var-1-2"
            onClick={() => handleCartItemClick("leafy-greens")}
          />
          <img
            src={vegetableCart3}
            alt=""
            className="inner-img-var-1-3"
            onClick={() => handleCartItemClick("root-vegetables")}
          />
        </div>
      </div>
      <MainCartModal activeCartData={activeCartData} />
    </>
  );
};

export default VegetablesCartLarge;
